function entitySetter(current, setImages, setVideos, setOnlineVideos) {
  setImages(current.images ?? [])
  setVideos(current.videos ?? [])
  setOnlineVideos(current.onlineVideos ?? [])
}

export { entitySetter }
